import React from 'react';
import {lowerCase, isEqual} from "lodash";
import BaseForm from "./BaseForm";
import validators from "../../../utils/forms/validators";
import * as preconfiguredInputs from "../../../utils/forms/preconfiguredInputs";
import formatters from "../../../utils/forms/formatters";
import nameMaps from "../../../utils/forms/nameMaps";

import BaseModal from "../modals/BaseModal";
import DataListCard from "../cards/DataListCard";



export default class LoansForm extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            inputs: {},
            editingIndex: null,
            modalOpen: false,
            formIncomplete: false
        }

        this.loanFormInputs = [
            {
                type: "text",
                dataKey: "holder_name",
                label: "Name of Loan Holder / Bank *",
                ...validators.isStringOfMinLength(2),
            },
            {
                type: "select",
                dataKey: "loan_type",
                label: "Type *",
                sublabel: "If other is selected, please give a description in comments",
                inputClasses: "is-fullwidth",
                controlClasses: "is-expanded",
                placeholder: "--",
                options: [
                    {
                        display: 'Bank',
                        value: 'bank'
                    },
                    {
                        display: 'CMBS',
                        value: 'cmbs'
                    },
                    {
                        display: 'SBA',
                        value: 'sba'
                    },
                    {
                        display: 'Other',
                        value: 'other'
                    }
                ],
                ...validators.exists,
            },
            {
                type: "select",
                dataKey: "loan_seniority",
                label: "Debt Seniority *",
                sublabel: "If other is selected, please give a description in comments",
                inputClasses: "is-fullwidth",
                controlClasses: "is-expanded",
                placeholder: "--",
                options: [
                    {
                        display: 'First',
                        value: 1
                    },
                    {
                        display: 'Second',
                        value: 2
                    },
                    {
                        display: 'Junior',
                        value: 3
                    },
                    {
                        display: "Don't know",
                        value: 0,
                    }
                ],
                ...validators.exists,
            },
            {
                type: "text",
                dataKey: "amount",
                label: "Amount *",

                ...validators.isNumber,
                ...formatters.USDCurrency
            },
            {
                type: "text",
                dataKey: "balance",
                label: "Balance *",

                ...validators.isNumber,
                ...formatters.USDCurrency
            },
            {
                type: "text",
                dataKey: "annual_payment_amount",
                label: "Annualized Payment Amount",

                ...validators.isNumber,
                ...formatters.USDCurrency
            },
            {
                type: "text",
                dataKey: "original_loan_term",
                label: "Original Term of Loan",
            },
            {
                type: "date",
                dataKey: "last_payment_schedule_date",
                label: "Last Payment Schedule Date (M/Y)",
                // validator: validators.exists
            },
            {
                type: "text",
                dataKey: "contact_name",
                label: "Name of Contact",
                // ...validators.isStringOfMinLength(2),
            },
            {
                type: "text",
                dataKey: "contact_phone",
                label: "Contact Phone",
            },
            {
                type: "text",
                dataKey: "contact_email",
                label: "Contact Email",
                ...validators.isEmailOrNull,
            },
        ]


    }

    static defaultProps = {
        loans: [],
        onLoanSubmit: () => null
    }

    componentDidUpdatecomponentDidUpdate(prevProps, prevState) {
        if (!isEqual(prevState.inputs, this.state.inputs)) {
            this.loanFormInputs = this.loanFormInputs.map(d => ({...d, value: this.state.inputs[d.dataKey]}));
        }
    }

    onLoanSubmit = (inputs) => {
        const {editingIndex} = this.state;
         this.setState({inputs, editingIndex: null, incompleteForm: false, modalOpen: false});
         this.props.onLoanSubmit(inputs, editingIndex);
    }

    onLoanRemove = (index) => {
        this.props.onLoanRemove(index);
    }

    onLoanEdit = (loan, index) => {
        this.setState({
            inputs: {...loan},
            editingIndex: index,
            modalOpen: true
        })
    }

    onFormIncomplete = () => this.setState({incompleteForm: true});

    populateInputs = () => {
        this.loanFormInputs.forEach(d => {
            d.value = this.state.inputs[d.dataKey];
        });

        return this.loanFormInputs;
    }

    onCancelForm = () => {
        this.setState({inputs: {}, modalOpen: false, editingIndex: null})
    }

    // where loan is just an object, as returned from the form
    renderLoanCard = (loan, index) => {


        // first make the title and pull it out of the object
        const title = loan.holder_name || 'No Bank Listed';

         let dataDisplayPoints = {...loan};
        delete dataDisplayPoints.holder_name;

        // now iterate through remaining keys, so I can get the formatting functions out of the form config
        Object.keys(dataDisplayPoints).forEach(k => {
             const matchingInput = this.loanFormInputs.find(input => input.dataKey === k);
             if (matchingInput && typeof matchingInput.formatter === 'function') {
                 dataDisplayPoints[k] = matchingInput.formatter(dataDisplayPoints[k])
             }
        })

        dataDisplayPoints.loan_seniority = nameMaps.loanSeniority(dataDisplayPoints.loan_seniority).display;


        return <DataListCard
                onEdit={() => this.onLoanEdit(loan, index)}
                onRemove={() => this.onLoanRemove(index)}
                data={dataDisplayPoints}
                title={title}
            />

    }


    render() {
        return (
            <>
                <div className="card-list-wrapper">
                    <p>If you don't have all this information, just fill it out to the best of your ability. You can return to update it during the underwriting process.</p>
                    <div className="button is-link my-5" onClick={() => this.setState({modalOpen: true})}> + Add a loan</div>

                    {this.props.loans.map((loan, index) => this.renderLoanCard(loan, index))}
                </div>


                {this.state.modalOpen &&
                    <BaseModal
                        visible
                        cardStyle={{maxHeight: '80vh'}}
                    >
                        <h3 className="is-size-3 has-text-link">Add a Loan</h3>

                        {this.state.formIncomplete &&
                        <div className="card has-background-danger has-text-white-bis my-3 mx-1 is-flex is-justify-content-center">
                            <h6 className="p-1">Please complete all required fields</h6>
                        </div>
                        }
                        <BaseForm
                            inputs={this.populateInputs(this.loanFormInputs)}
                            disableAutocomplete
                            onSubmit={this.onLoanSubmit}
                            onCancel={this.onCancelForm}
                            onSubmissionFailure={this.onFormIncomplete}
                        />
                    </BaseModal>
                }

            </>
        )
    }



}
